/*
  Para incluir novas paginas no side bar existem alguns passos :
  10 - Definir a rota principal em router/index.js
  20 - Definir a rota de navegação em /admin/app-sidebar/NavigationRoutes.js.
  30 - Definir quais privilegios serão necessarios para acessar essa pagina e adiciona-los no /utils/privilegios.js
  40 - adicionar a rota em /admin/app-sidebar/AppSidebar.vue em dicioPriv e definir o metodo de validação de privilegios.
  50 - dentro do Sp360 em gerenciamento -> privilegios, criar o privilegio no backend.
  60 - dentro do Sp360 em gerenciamento -> perfis, adicionar o privileigio aos perfis pertinentes.
*/

export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      path: '/',
      redirect: {
        name: 'mainDashboard',
      },
    },
    {
      path: '/dashboard',
      redirect: {
        name: 'mainDashboard',
      },
    },
    {
      path: '*',
      redirect: {
        name: 'mainDashboard',
      },
    },
    {
      path: '/auth',
      name: 'auth',
      component: 'AuthLayout',
      children: [
        {
          name: 'login',
          path: 'login',
          component: '@/components/auth/login/Login.vue',
        },
        {
          name: 'signup',
          path: 'signup',
          component: '@/components/auth/signup/Signup.vue',
        },
        {
          path: '',
          redirect: { name: 'login' },
        },
      ],
    },
    { path: '/error',
      name: 'error',
      component: 'EmptyParentComponent',
      children: [{
        name: 'vuestic-connection-error-large-text',
        path: 'connection-error',
        component: '@/components/pages/500-pages/VuesticConnectionErrorLargeText.vue',
      } ],
    },
    {
      path: '/sp360',
      name: 'sp360',
      component: 'AppLayout',
      props: '(route) => ({query: route.query.scr})',
      children: [
        {
          path: '',
          redirect: { name: 'mainDashboard' },
        },
        { name: 'mainDashboard',
          path: 'mainDashboard',
          component: '@/components/dashboard/MainDashboard.vue',
          default: true,
        },
        { name: 'crisis-monitor',
          path: 'crisis-monitor',
          displayName: 'menu.crisis-monitor',
          component: 'EmptyParentComponent',
          metaNavigation: { iconClass: 'fa fa-exclamation-triangle' },
          children: [
          {
            name: 'covid-19-SEAD',
            path: 'covid-19-SEAD',
            component: '@/components/dashboard/crise/covid-19.vue',
            displayName: 'menu.corona-sead',
            privileges: ['CRISE_CORONA_VIRUS']
          },
          {
            name: 'covid-19-compras',
            path: 'covid-19-compras',
            component: '@/components/dashboard/crise/covid-19-compras.vue',
            displayName: 'menu.corona-compras',
            privileges: ['CRISE_CORONA_VIRUS_COMPRAS']
          },
          {
            name: 'covid-19-doacoes',
            path: 'covid-19-doacoes',
            component: '@/components/dashboard/crise/covid-19-doacoes.vue',
            displayName: 'menu.corona-doacoes',
            privileges: ['CRISE_CORONA_VIRUS_DOACOES']
          },
          {
            name: 'covid-19-social',
            path: 'covid-19-social',
            component: '@/components/dashboard/crise/covid-19-social.vue',
            displayName: 'menu.corona-social',
            privileges: ['CRISE_CORONA_VIRUS_SOCIAL']
          },
          {
            name: 'covid-19-municipio',
            path: 'covid-19-municipio',
            component: '@/components/dashboard/crise/covid-19-painel-municipio.vue',
            displayName: 'menu.corona',
            privileges: ['SAUDE_COVID_CASOS_OBITOS', 'SAUDE_COVID_ISOLAMENTO_SOCIAL', 'SAUDE_COVID_ACOES_PMSP']
          },
          {
            name: 'covid-cidade-solidaria',
            path: 'covid-cidade-solidaria',
            component: '@/components/dashboard/crise/cidade-solidaria.vue',
            displayName: 'menu.cidade-solidaria',
            privileges: ['CRISE_CIDADE_SOLIDARIA']
          }],
        },
        { name: 'eixos',
          path: 'eixo',
          component: 'EmptyParentComponent',
          displayName: 'menu.axis',
          metaNavigation: { iconClass: 'fa fa-university' },
          children: [{
            name: 'eixo-social',
            path: 'social',
            component: '@/components/dashboard/eixos/social.vue',
            displayName: 'menu.social',
            privileges: ['EIXO_SOCIAL', 'SAUDE_ESTOQUE_REMEDIOS', 'SAUDE_ESTOQUE_REMEDIOS_POR_UNIDADE', 'EDUCACAO_FILA_DAS_CRECHES', 'POPULACAO_DEMOGRAFIA_POPULACIONAL', 
            'EDUCACAO_INSTITUICOES_ENSINO', 'ORCAMENTO_EIXO_SOCIAL']
          },
          {
            name: 'eixo-institucional',
            path: 'institucional',
            component: '@/components/dashboard/eixos/institucional.vue',
            displayName: 'menu.institutional',
            privileges: ['EIXO_INSTITUCIONAL', 'FOLHAPAGAMENTO_CONSOLIDADO_CARGO', 'FOLHAPAGAMENTO_CONSOLIDADO_ORGAO', 'FOLHAPAGAMENTO_CONSOLIDADO_ESCOLARIDADE', 'FOLHAPAGAMENTO_CONSOLIDADO_TIPO_REGIME']
          },
          {
            name: 'eixo-urbano',
            path: 'urbano',
            component: '@/components/dashboard/eixos/urbano.vue',
            displayName: 'menu.urban',
            privileges: ['EIXO_URBANO', 'SP156_SOLICITACOES_EVOLUCAO_ESTOQUE', 'SP156_SOLICITACOES_POR_CANAL', 'SP156_TOP_SERVICOS_POR_REGIAO']
          }],
        },
        { name: 'raio-x',
          path: 'raiox',
          component: '@/components/dashboard/raiox/raio-x-regiao.vue',
          displayName: 'menu.raiox',
          metaNavigation: { iconClass: 'fa fa-binoculars' },
          privileges: ['RAIOX_MUNICIPIO']
        },
        { name: 'educacao',
          path: 'educacao',
          component: 'EmptyParentComponent',
          displayName: 'menu.education',
          metaNavigation: { iconClass: 'fa fa-graduation-cap' },  
          children: [
            {
              name: 'educacao-fila-creche',
              path: 'fila-da-creche',
              component: '@/components/dashboard/educacao/fila-da-creche.vue',
              displayName: 'menu.daycare-wait-list',
              privileges: ['EDUCACAO_FILA_DAS_CRECHES', 'POPULACAO_DEMOGRAFIA_POPULACIONAL']
            },
            {
              name: 'educacao-socioeconomico',
              displayName: 'Indicadores Socioeconômicos',
            },
            {
              name: 'educacao-vagas-matriculas',
              path: 'educacao-vagas-matriculas',
              component: '@/components/dashboard/educacao/matriculas.vue',
              displayName: 'menu.school-enrollment',
              privileges: ['EDUCACAO_MATRICULAS']
            },
            {
              name: 'educacao-rede-municipal',
              path: 'educacao-rede-municipal',
              component: '@/components/dashboard/educacao/escolas.vue',
              displayName: 'menu.school-system',
              privileges: ['EDUCACAO_INSTITUICOES_ENSINO']
            },
            {
              name: 'educacao-mapa-demanda-creches',
              path: 'educacao-mapa-demanda-creches',
              component: '@/components/dashboard/educacao/mapa-demanda.vue',
              displayName: 'menu.daycare-demand-heatmap',
              privileges: ['EDUCACAO_INSTITUICOES_ENSINO']
            },
            {
              name: 'educacao-tma-creche',
              path: 'educacao-tma-creche',
              component: '@/components/dashboard/educacao/tmaCreche.vue',
              displayName: 'menu.daycare-tma',
              privileges: ['EDUCACAO_TMA_CRECHE']
            },
            {
              name: 'educacao-ativo-inativo-professores',
              path: 'educacao-ativo-inativo-professores',
              component: '@/components/dashboard/educacao/ativos-inativos-professores.vue',
              displayName: 'menu.educacao-folha-professores',
              privileges: ['FOLHAPAGAMENTO_PROFESSORES_CONSOLIDADO_TIPO_REGIME','FOLHAPAGAMENTO_PROFESSORES_CONSOLIDADO_CARGO',
              'FOLHAPAGAMENTO_PROFESSORES_REGIME_CONTRATACAO','FOLHAPAGAMENTO_PROFESSORES_CONSOLIDADO_RACA_SEXO',
              'FOLHAPAGAMENTO_PROFESSORES_FAIXA_ETARIA']
            },
          ],
        },
        { name: 'saude',
          path: 'saude',
          component: 'EmptyParentComponent',
          displayName: 'menu.health',
          metaNavigation: { iconClass: 'fa fa-ambulance' },
          children: [{
            name: 'estoque-medicamentos',
            path: 'estoque-medicamentos',
            component: '@/components/dashboard/saude/estoqueMedicamentos.vue',
            displayName: 'menu.medicineSupply',
            privileges: ['SAUDE_ESTOQUE_REMEDIOS', 'SAUDE_ESTOQUE_REMEDIOS_POR_UNIDADE']
          },
          {
            name: 'fila-atendimento-exame',
            path: 'fila-atendimento-exame',
            component: '@/components/dashboard/saude/filaAtendimentoExame.vue',
            displayName: 'menu.medical-exams-row',
            privileges: ['SAUDE_FILA_EXAME_CONSULTA_POR_ESPECIALIDADE', 'SAUDE_FILA_EXAME_POR_ESPECIALIDADE',
            'SAUDE_FILA_EXAME_POR_ESPECIALIDADE_POR_REGIAO', 'SAUDE_FILA_EXAME_POR_ESPECIALIDADE_POR_SUBGRUPO',
            'SAUDE_FILA_EXAME_POR_PROCEDIMENTO','SAUDE_FILA_EXAME_POR_PROCEDIMENTO_POR_REGIAO',
            'SAUDE_FILA_EXAME_POR_TIPO_PROCEDIMENTO','SAUDE_FILA_EXAME_POR_TIPO_PROCEDIMENTO_POR_REGIAO']
          },
          {
            name: 'equipamentos-saude',
            path: 'equipamentos-saude',
            component: '@/components/dashboard/saude/saudeEquipamentos.vue',
            displayName: 'Dados dos equipamentos',
            privileges: ['SAUDE_EQUIPAMETOS']
          },
          {
            name: 'profissionais-saude',
            path: 'profissionais-saude',
            component: '@/components/dashboard/saude/saudeProfissionais.vue',
            displayName: 'Dados dos profissionais',
            privileges: ['SAUDE_QUANTITATIVOS_PROFISSIONAIS_POR_QUALIFICADOR']
          },
          {
            name: 'medicamentos-regionalizados',
            path: 'medicamentos-regionalizados',
            component: '@/components/dashboard/saude/estoquedeMedicamentosPorRegiaoEFarmacia.vue',
            displayName: 'menu.medicamentos-regionalizados',
            privileges: ['SAUDE_ESTOQUE_POR_REMEDIO_POR_UNIDADE']
          },
          {
            name: 'saude-fila-cirurgia',
            path: 'saude-fila-cirurgia',
            component: '@/components/dashboard/saude/fila-cirurgia.vue',
            displayName: 'menu.saude-fila-cirurgia',
            privileges: ['SAUDE_FILA_PROCEDIMENTO_CONSOLIDADO_POR_CLASSE', 'SAUDE_FILA_PROCEDIMENTO_POR_PROCEDIMENTO',
            'SAUDE_FILA_PROCEDIMENTO_POR_ESPECIALIDADE','SAUDE_FILA_PROCEDIMENTO_POR_GRUPO_PROCEDIMENTO',
            'SAUDE_FILA_PROCEDIMENTO_DETALHADO_POR_CLASSE_PROCEDIMENTO','SAUDE_FILA_PROCEDIMENTO_DETALHADO']
          },
          {
            name: 'saude-fila-consultas',
            path: 'saude-fila-consultas',
            component: '@/components/dashboard/saude/fila-consultas.vue',
            displayName: 'menu.saude-fila-consultas',
            privileges: ['SAUDE_FILA_PROCEDIMENTO_CONSOLIDADO_POR_CLASSE', 'SAUDE_FILA_PROCEDIMENTO_POR_PROCEDIMENTO',
            'SAUDE_FILA_PROCEDIMENTO_POR_ESPECIALIDADE','SAUDE_FILA_PROCEDIMENTO_POR_GRUPO_PROCEDIMENTO',
            'SAUDE_FILA_PROCEDIMENTO_DETALHADO_POR_CLASSE_PROCEDIMENTO','SAUDE_FILA_PROCEDIMENTO_DETALHADO']
          },
          {
            name: 'demanda-regionalizada',
            path: 'demanda-regionalizada',
            component: '@/components/dashboard/saude/demandaRegionalizada.vue',
            displayName: 'menu.regional-demand',
            privileges: ['SAUDE_FILA_EXAME_POR_TIPO_PROCEDIMENTO_POR_REGIAO']
          },
          ],
        },
        { name: 'sp156',
          path: 'sp156',
          component: 'EmptyParentComponent',
          displayName: 'menu.sp156',
          metaNavigation: { iconClass: 'fa fa-phone' },
          children: [{
            name: 'atendimento-solicitacoes',
            path: 'atendimento-solicitacoes',
            component: '@/components/dashboard/atendimento/atendimento-solicitacoes.vue',
            displayName: 'menu.inbound-channel',
            privileges: ['SP156_SOLICITACOES_POR_CANAL', 'SP156_SOLICITACOES_CONSOLIDADO']
          },
          {
            name: 'servicos-solicitados',
            path: 'servicos-solicitados',
            component: '@/components/dashboard/atendimento/servicosSolicitados.vue',
            displayName: 'menu.service-requests',
            privileges: ['SP156_TOP_SERVICOS_POR_REGIAO', 'SP156_SOLICITACOES_POR_ORGAO', 'SP156_SERVICOS_NAO_GEORREFERENCIADOS']
          },
          {
            name: 'servicos-ouvidoria',
            path: 'servicos-ouvidoria',
            component: '@/components/dashboard/atendimento/servicos-ouvidoria.vue',
            displayName: 'menu.servicos-ouvidoria',
            privileges: ['SP156_SERVICOS_NAO_GEORREFERENCIADOS_OUVIDORIA', 'SP156_SOLICITACOES_CONSOLIDADO_OUVIDORIA',
            'SP156_SOLICITACOES_OUVIDORIA_POR_ORGAO','SP156_TOP_ASSUNTOS_DEMANDADOS_OUVIDORIA',
            'SP156_TOP_SERVICOS_OUVIDORIA_CONSOLIDADOS','SP156_TOP_SERVICOS_OUVIDORIA_POR_REGIAO',
            'SP156_TOP_TEMAS_DEMANDADOS_OUVIDORIA','SP156_TOP_SERVICOS_OUVIDORIA_POR_ORGAO']
          },
          {
            name: 'estoque-servicos',
            path: 'estoque-servicos',
            component: '@/components/dashboard/atendimento/estoque-servicos.vue',
            displayName: 'menu.service-stockpile',
            privileges: ['SP156_SOLICITACOES_POR_CANAL', 'SP156_SOLICITACOES_EVOLUCAO_ESTOQUE']
          },
          {
            name: 'boletim-servicos',
            path: 'boletim-servicos',
            component: '@/components/dashboard/atendimento/boletim-servicos.vue',
            displayName: 'menu.boletim-servicos',
            privileges: ['SP156_BOLETIM','SP156_SOLICITACOES_EVOLUCAO_ESTOQUE',
            'SP156_TOP_SERVICOS_POR_REGIAO','SP156_TOP_SERVICOS_CONSOLIDADOS',
            'SP156_TOP_SERVICOS_DEMANDADOS','SP156_TOP_SERVICOS_OUVIDORIA_POR_REGIAO',
            'SP156_SOLICITACOES_POR_CANAL']
          },
          ],
        },
        { name: 'populacao',
          path: 'populacao',
          component: 'EmptyParentComponent',
          displayName: 'menu.population',
          metaNavigation: { iconClass: 'fa fa-group' },
          children: [{
            name: 'demografia-populacional',
            path: 'demografia-populacional',
            component: '@/components/dashboard/populacao/demografiaPopulacional.vue',
            displayName: 'menu.population-demography',
            privileges: ['POPULACAO_DEMOGRAFIA_POPULACIONAL']
          },
          {
            name: 'dados-empregaticios',
            path: 'dados-empregaticios',
            component: '@/components/dashboard/populacao/dadosEmpregaticios.vue',
            displayName: 'menu.employment-data',
            privileges: ['POPULACAO_ADMISSAO_DESLIGAMENTO_SETOR', 'POPULACAO_HISTORICO_ADMISSAO_SETOR', 'POPULACAO_HISTORICO_ADMISSAO_DESLIGAMENTO', 
            'POPULACAO_TOTAL_ADMISSAO_REGIAO_MACRO_MICRO']
          },
          {
            name: 'auxilio-aluguel',
            path: 'auxilio-aluguel',
            component: '@/components/dashboard/populacao/auxilioAluguel.vue',
            displayName: 'menu.rent-support',
            privileges: ['POPULACAO_HABITACAO_AUXILIO_ALUGUEL']
          },
          ],
        },
        { name: 'empreenda-facil',
          path: 'empreenda-facil',
          component: 'EmptyParentComponent',
          displayName: 'menu.empreendafacil',
          metaNavigation: { iconClass: 'fa fa-check-square' },
          children: [{
            name: 'solicitacoes-setores',
            path: 'solicitacoes-setores',
            component: '@/components/dashboard/empreenda-facil/solicitacoes-setores.vue',
            displayName: 'menu.solicitacoes-setores',
            privileges: ['POPULACAO_ADMISSAO_DESLIGAMENTO_SETOR']
          },
          {
            name: 'licenciamentos',
            path: 'licenciamentos',
            component: '@/components/dashboard/empreenda-facil/licenciamentos.vue',
            displayName: 'menu.licenciamentos',
            privileges: ['LICENCIAMENTOEMPRESA_TEMPO_MEDIO_LICENCAS_POR_ANO', 'LICENCIAMENTOEMPRESA_CONSOLIDADO_LICENCAS_POR_SECAO', 
            'LICENCIAMENTOEMPRESA_LICENCAS_POR_SUBPREFEITURA_POR_PERIODO_FECHADO']
          },
          {
            name: 'analise-viabilidade',
            path: 'analise-viabilidade',
            component: '@/components/dashboard/empreenda-facil/analise-viabilidade.vue',
            displayName: 'menu.analise-viabilidade',
            privileges: ['LICENCIAMENTOEMPRESA_ANALISE_VIABILIDADE_POR_ABERTURA_SOLICITACAO_POR_INTERVALO', 'LICENCIAMENTOEMPRESA_ANALISE_VIABILIDADE_ESTABELECIMENTOS_POR_INTERVALO', 
            'LICENCIAMENTOEMPRESA_ANALISE_VIABILIDADE_RESULTADO_POR_INTERVALO', 'LICENCIAMENTOEMPRESA_LICENCAS_POR_SUBPREFEITURA_POR_PERIODO_FECHADO']
          },
          {
            name: 'ccm-empresas',
            path: 'ccm-empresas',
            component: '@/components/dashboard/empreenda-facil/ccm-empresas.vue',
            displayName: 'menu.ccm-empresas',
            privileges: ['LICENCIAMENTOEMPRESA_CCM_EMPRESAS_NO_INTERVALO', 'LICENCIAMENTOEMPRESA_CCM_EMPRESAS_EMPREENDAFACIL_POR_INTERVALO']
          }],
        },
        { name: 'mobilidade',
          path: 'mobilidade',
          component: 'EmptyParentComponent',
          displayName: 'menu.mobillity',
          metaNavigation: { iconClass: 'fa fa-automobile' },
          children: [{
            name: 'mobilidade-transito',
            path: 'mobilidade-transito',
            component: '@/components/dashboard/mobilidade/transitoDashboard.vue',
            displayName: 'menu.traffic',
            privileges: ['MOBILIDADE_MAPA_TRANSITO']
          },
          {
            name: 'mobilidade-transportes',
            path: 'mobilidade-transportes',
            component: '@/components/dashboard/mobilidade/transportes.vue',
            displayName: 'menu.transportes',
            privileges: ['MOBILIDADE_TOTAL_PASSAGEIROS_SPTRANS_TRANSPORTADOS_SAZONAL', 'MOBILIDADE_TRANSPORTE_SPTRANS_TOTAL_PASSAGEIROS_ESTATISTICAS_MES', 'MOBILIDADE_TOTAL_PASSAGEIROS_SPTRANS_CONSOLIDADO']
          },
          ],
        },
        { name: 'gestao-orcamentaria',
          path: 'gestao-orcamentaria',
          displayName: 'menu.strategic',
          component: 'EmptyParentComponent',
          metaNavigation: { iconClass: 'fa fa-bullseye' },
          children: [
          {
            name: 'orcamento-orgao',
            path: 'orcamento-orgao',
            component: '@/components/dashboard/orcamento/dashboardOrcamentoOrgao.vue',
            displayName: 'menu.orcamentoOrgao',
            privileges: ['ORCAMENTO_ORGAO']
          },
          {
            name: 'orcamento-consolidado',
            path: 'orcamento-consolidado',
            component: '@/components/dashboard/orcamento/dashboardOrcamentoConsolidado.vue',
            displayName: 'menu.orcamentoConsolidado',
            privileges: ['ORCAMENTO_CONSOLIDADO']
          },
          {
            name: 'orcamento-funcoes-governo',
            path: 'orcamento-funcoes-governo',
            component: '@/components/dashboard/orcamento/dashboardOrcamentoFuncoesGoverno.vue',
            displayName: 'menu.orcamentoFuncoesGoverno',
            privileges: ['ORCAMENTO_FUNCOES_GOVERNO']
          },
          {
            name: 'orcamento-fonte-recursos',
            path: 'orcamento-fonte-recursos',
            component: '@/components/dashboard/orcamento/dashboardOrcamentoFonteRecursos.vue',
            displayName: 'menu.orcamentoFonteRecursos',
            privileges: ['ORCAMENTO_FONTE_RECURSOS']
          },
          {
            name: 'orcamento-natureza-despesas',
            path: 'orcamento-natureza-despesas',
            component: '@/components/dashboard/orcamento/dashboardOrcamentoNaturezaDespesas.vue',
            displayName: 'menu.orcamentoNaturezaDespesas',
            privileges: ['ORCAMENTO_NATUREZA_DESPESAS']
          }
          ],
        },
        {
          name: 'gestao-metas',
          path: 'gestao-metas',
          component: '@/components/dashboard/estrategico/planoDeMetas.vue',
          displayName: 'menu.goals',
          metaNavigation: { iconClass: 'fa fa-line-chart' },
          privileges: ['METAS_PAINEL_STATUS_PROGRAMA_METAS']
        },
        { name: 'funcionalismo',
          path: 'funcionalismo',
          component: 'EmptyParentComponent',
          displayName: 'menu.funcionalismo',
          metaNavigation: { iconClass: 'fa fa-id-card-o' },
          children: [{
            name: 'ativosInativos',
            path: 'ativosInativos',
            component: '@/components/dashboard/funcionalismo/ativos-inativos.vue',
            displayName: 'menu.servidores',
            privileges: ['FOLHAPAGAMENTO_CONSOLIDADO_RACA_SEXO', 'FOLHAPAGAMENTO_CONSOLIDADO_CARGO',
          'FOLHAPAGAMENTO_CONSOLIDADO_ORGAO', 'FOLHAPAGAMENTO_CONSOLIDADO_ESCOLARIDADE', 
          'FOLHAPAGAMENTO_CONSOLIDADO_TIPO_REGIME', 'FOLHAPAGAMENTO_FAIXA_ETARIA_ATIVOS']
          },
          {
            name: 'historico-servidores',
            path: 'historico-servidores',
            component: '@/components/dashboard/funcionalismo/historico-servidores.vue',
            displayName: 'menu.historicoServidores',
            privileges: ['FOLHAPAGAMENTO_HISTORICO_ADMISSAO_VACANCIA_SERVIDORES', 'FOLHAPAGAMENTO_HISTORICO_ADMISSAO_SERVIDORES_INTERVALO',
          'FOLHAPAGAMENTO_HISTORICO_VACANCIA_SERVIDORES_INTERVALO', 'FOLHAPAGAMENTO_HISTORICO_APOSENTADORIA_SERVIDORES_INTERVALO',
        'FOLHAPAGAMENTO_HISTORICO_SERVIDORES_CARACTERISTICAS_INTERVALO']
          },
          {
            name: 'servidores-pcd',
            displayName: 'menu.servidoresPcd',
          }
          ],
        },
        { name: 'assistencia-social',
          path: 'social-security-net',
          component: 'EmptyParentComponent',
          displayName: 'menu.social-security-net',
          metaNavigation: { iconClass: 'fa fa-hotel' },
          children: [
          {
            name: 'social-ocupacao-abrigos',
            path: 'social-ocupacao-abrigos',
            component: '@/components/dashboard/assistencia-social/ocupacao-abrigos.vue',
            displayName: 'menu.homeless-shelter-occupancy',
            privileges: ['ASSISTENCIASOCIAL_OCUPACAO_ABRIGOS']
          },
          {
            name: 'social-vagas-abrigos',
            path: 'social-vagas-abrigos',
            component: '@/components/dashboard/assistencia-social/vagas-abrigos.vue',
            displayName: 'menu.homeless-shelter-vacancies',
            privileges: ['ASSISTENCIASOCIAL_VAGAS_CONTRATADAS']
          },
          {
            name: 'social-perfil-ocupantes',
            path: 'social-perfil-ocupantes',
            component: '@/components/dashboard/assistencia-social/perfil-ocupantes.vue',
            displayName: 'menu.assistencia-social-perfil-ocupantes',
            privileges: ['ASSISTENCIASOCIAL_PERFIL_OCUPACOES_AGRUPADO_ULTIMO_MES', 'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_CONSOLIDADO_ULTIMO_MES',
            'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_HISTORICO_CONSOLIDADO', 'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_HISTORICO_POR_SUBPREFEITURA',
            'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_HISTORICO_POSSIBILIDADES_FILTRO']
          },
          {
            name: 'social-servicos-regionalizados',
            path: 'social-servicos-regionalizados',
            component: '@/components/dashboard/assistencia-social/servicos-regionalizados.vue',
            displayName: 'menu.assistencia-social-servicos-regionalizados',
            privileges: ['ASSISTENCIASOCIAL_PERFIL_OCUPACOES_AGRUPADO_ULTIMO_MES', 'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_CONSOLIDADO_ULTIMO_MES',
          'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_HISTORICO_CONSOLIDADO', 'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_HISTORICO_POR_SUBPREFEITURA',
          'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_HISTORICO_POSSIBILIDADES_FILTRO', 'ASSISTENCIASOCIAL_VAGAS_ACOLHIMENTO_POR_SUB_ULTIMO_MES']
          },
          {
            name: 'renda-basica-emergencial',
            path: 'renda-basica-emergencial',
            component: '@/components/dashboard/assistencia-social/renda-basica-emergencial.vue',
            displayName: 'menu.assistencia-social-renda-basica-emergencial',
            privileges: ['ASSISTENCIASOCIAL_RENDA_BASICA_EMERGENCIA']
          },
          {
            name: 'censo-populacao-de-rua',
            displayName: 'menu.assistencia-social-censo-populacao-de-rua',
          },
          ],
        },
        { name: 'direitos-humanos',
          path: 'direitos-humanos',
          component: 'EmptyParentComponent',
          displayName: 'menu.direitos-humanos',
          metaNavigation: { iconClass: 'fa fa-hand-grab-o'},
          children: [{
            name: 'rede-servicos',
            path: 'rede-servicos',
            component: '@/components/dashboard/direitos-humanos/rede-servicos-direitos-humanos.vue',
            displayName: 'menu.direitos-humanos-rede-servicos',
            privileges: ['DIREITOSHUMANOS_SERVICOS']
          },
          ],
        },
      ],
    },
    { name: 'gerenciamento',
      path: '/management',
      component: 'AppLayout',
      props: '(route) => ({ query: route.query.scr })',
      displayName: 'menu.management',
      metaNavigation: { iconClass: 'fa fa-cogs'},
      children: [{
        name: 'users',
        path: 'users',
        component: '@/components/management/usuarios.vue',
        displayName: 'menu.users',
        privileges: ['USUARIO_CRUD']
      },
      { name: 'relatorio-acessos',
        path: 'relatorio-acessos',
        component: '@/components/dashboard/sp360/relatorio-acessos.vue',
        displayName: 'menu.relatorio',
        privileges: ['SP360_RELATORIO_ACESSO']
      },
      {
        name: 'dados',
        path: 'dados',
        component: '@/components/management/dataflow.vue',
        displayName: 'menu.dados',
        privileges: ['DADOS_MANAGEMENT']
      },
      {
        name: 'localizations',
        path: 'localizations',
        component: '@/components/management/localizacao.vue',
        displayName: 'menu.localizations',
        privileges: ['LOCALIZACAO_CRUD']
      },
      {
        name: 'profiles',
        path: 'profiles',
        component: '@/components/management/perfis.vue',
        displayName: 'menu.profiles',
        privileges: ['PERFIL_CRUD']
      },
      {
        name: 'privileges',
        path: 'privileges',
        component: '@/components/management/privilegios.vue',
        displayName: 'menu.privileges',
        privileges: ['PRIVILEGIO_CRUD']
      },
      {
        name: 'units',
        path: 'units',
        component: '@/components/management/unidades.vue',
        displayName: 'menu.units',
        privileges: ['UNIDADE_CRUD']
      },
      {
        name: 'iframes',
        path: 'iframes',
        component: '@/components/management/iframes.vue',
        displayName: 'menu.iframes',
        privileges: ['IFRAME_CRUD']
      },
      {
        name: 'rotas',
        path: 'rotas',
        component: '@/components/management/rotas.vue',
        displayName: 'menu.rotas',
        privileges: ['ROTAS_CRUD']
      }],
    },
  ]
}
